export default __webpack_public_path__ + "static/media/ars.7bbd8911.svg";